import { render, staticRenderFns } from "./CustomerGoal.vue?vue&type=template&id=384ffcc3&scoped=true&"
import script from "./CustomerGoal.vue?vue&type=script&lang=js&"
export * from "./CustomerGoal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGoal.vue?vue&type=style&index=0&id=384ffcc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ffcc3",
  null
  
)

export default component.exports